import axios from "axios";
import React, { useEffect } from "react";
import Header from "./Header";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function ReferralInvitation() {
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let ref = params.get("ref"); // 123
    let token = localStorage.getItem("token");

    axios({
      url: `https://api.talaeshow.com/api/users/register/?invitation_code=${ref}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        if (res.status == 200) {
          let data = res.data;
          if (data) {
            toast.success("کد دعوت با موفقیت تایید شد.");
            navigate("/info");
          }
        }
      })
      .catch((e) => {
        toast.error("کد دعوت تایید نشد.");
        navigate("/info");
      });
  }, []);

  return (
    <>
      <Header />
      <div className="invitation-wrapper">
        <div className="invitation-loading">
          <img src={"/gold-loading.svg"} alt={""} className={"w-loading"} />
        </div>
        <div>در حال بررسی کد دعوت</div>
      </div>
    </>
  );
}
